import React from "react";
import { Pressable, StyleSheet, Text, TextInput, View } from "react-native";
import TOKENS from "../styles/tokens";

type Props = {
  value: string;
  onChange: (value: string) => void;
  onFormat: () => void;
  onResetToTemplate: () => void;
  parseError: string | null;
};

const JsonMappingEditor: React.FC<Props> = ({
  value,
  onChange,
  onFormat,
  onResetToTemplate,
  parseError,
}) => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>JSON Mapping</Text>
      <Text style={styles.helperText}>
        Edit mapping JSON directly. Use format before save.
      </Text>
      <TextInput
        style={styles.editor}
        value={value}
        onChangeText={onChange}
        multiline
        autoCapitalize="none"
        autoCorrect={false}
        spellCheck={false}
      />
      {parseError ? <Text style={styles.errorText}>{parseError}</Text> : null}
      <View style={styles.actions}>
        <Pressable style={styles.actionButton} onPress={onFormat}>
          <Text style={styles.actionText}>Format JSON</Text>
        </Pressable>
        <Pressable style={styles.actionButton} onPress={onResetToTemplate}>
          <Text style={styles.actionText}>Reset to Template</Text>
        </Pressable>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    gap: TOKENS.spacing.sm,
  },
  title: {
    fontFamily: TOKENS.font.semibold,
    fontSize: TOKENS.fontSize.lg,
    lineHeight: TOKENS.lineHeight.lg,
    color: TOKENS.color.textPrimary,
  },
  helperText: {
    fontFamily: TOKENS.font.regular,
    fontSize: TOKENS.fontSize.sm,
    lineHeight: TOKENS.lineHeight.sm,
    color: TOKENS.color.textSecondary,
  },
  editor: {
    minHeight: 320,
    borderRadius: TOKENS.radius.lg,
    borderWidth: 1,
    borderColor: TOKENS.color.borderStrong,
    backgroundColor: TOKENS.color.codeBg,
    color: TOKENS.color.codeText,
    padding: TOKENS.spacing.sm,
    fontFamily: TOKENS.font.mono,
    fontSize: TOKENS.fontSize.xs,
    lineHeight: TOKENS.lineHeight.xs,
    textAlignVertical: "top",
  },
  errorText: {
    fontFamily: TOKENS.font.medium,
    fontSize: TOKENS.fontSize.xs,
    color: TOKENS.color.error,
  },
  actions: {
    flexDirection: "row",
    gap: TOKENS.spacing.xs,
    flexWrap: "wrap",
  },
  actionButton: {
    minHeight: 44,
    borderRadius: TOKENS.radius.md,
    borderWidth: 1,
    borderColor: TOKENS.color.borderStrong,
    justifyContent: "center",
    paddingHorizontal: TOKENS.spacing.sm,
  },
  actionText: {
    fontFamily: TOKENS.font.medium,
    fontSize: TOKENS.fontSize.xs,
    color: TOKENS.color.textSecondary,
  },
});

export default JsonMappingEditor;
